import EmptyComponent from './empty-component';
export default EmptyComponent;
